<ng-template [ngIf]="!deviceService.isMobile()">
  <div class="content-selector" [class.visible]="visible" [class.withOverlay]="!item">
    <div class="overlay" (click)="closed.emit(true)" *ngIf="!item"></div>
    <ng-container *ngTemplateOutlet="selectorNormal"></ng-container>
  </div>
</ng-template>

<ng-template #selectorNormal>
  <div class="container">
    <div class="header" [class.tablet]="deviceService.isTablet()">
      <div class="hint-block">
        <p class="title">
          {{
            (isAddLessonsFromContent
              ? 'collections-constructor.content-selector.title-lesson'
              : 'collections-constructor.content-selector.title'
            ) | customLocale
          }}
        </p>
        <p class="invalid-hint" *ngIf="isInvalid">
          {{ 'collections-constructor.content-selector.invalid-hint' | customLocale }} "{{
            'collections-constructor.content-selector.add-lesson' | customLocale
          }}"
        </p>
      </div>
      <div class="search-block">
        <label class="search">
          <app-icon width="18" height="18" icon="search"></app-icon>
          <input
            name="search"
            class="input"
            [attr.placeholder]="'collections-constructor.content-selector.search-placeholder' | customLocale"
            [(ngModel)]="term"
            (change)="updateFilter()"
            (keyup.enter)="updateFilter()"
            (keyup.backspace)="term.length < 1 && updateFilter()"
            (keyup)="updateFilterTerm()" />
        </label>
        <ng-template [ngIf]="btnState === 'default'" [ngIfElse]="savedState">
          <on-ui-button
            class="primary"
            (click)="saveSelection()"
            [label]="'collections-constructor.content-selector.add-lesson'">
          </on-ui-button>
        </ng-template>
        <ng-template #savedState>
          <on-ui-button *ngIf="btnState === 'added'" class="secondary outline" label="content-mini-card.added">
          </on-ui-button>

          <on-ui-button
            *ngIf="btnState === 'alreadyAdded'"
            class="danger outline"
            label="content-mini-card.already-added">
          </on-ui-button>
        </ng-template>
      </div>
    </div>

    <div class="content">
      <div class="scroll-field">
        <ul class="filter-list">
          <li class="filter-item medium" [class.active]="!contentType" (click)="selectContentType(null)">
            {{ 'content-type-title.all' | customLocale }}
          </li>
          <li
            *ngFor="let option of contentTypesOptions; trackBy: trackByFn"
            class="filter-item medium"
            [class.active]="contentType === option.id"
            (click)="selectContentType(option.id)">
            {{ option.title | customLocale }}
          </li>
        </ul>
      </div>
      <!-- <div *ngFor="let content of items.items; trackBy: trackContentById">{{ content.title }}</div> -->
      <ng-container *ngIf="items.items.length; else noContentRef">
        <app-content-carousel>
          <app-content-card-mini-readonly
            *ngFor="let content of items.items; trackBy: trackContentById"
            [isLessonSelected]="isLessonOnCollection(content.id)"
            [invalid]="isInvalid"
            [active]="isSelected(content.id)"
            [item]="content"
            [width]="width"
            (click)="selectItem(content)"></app-content-card-mini-readonly>
          <span *ngIf="items.loaded && !items.pagination.total" class="content-not-found">Nothing found</span>
          <input type="hidden" />
        </app-content-carousel>
      </ng-container>

      <ng-template #noContentRef>
        <div class="no-content-block">
          <div class="no-content">
            <span class="text" *ngIf="!isAddLessonsFromContent">{{
              'collections-constructor.content-selector.no-lessons1' | customLocale
            }}</span>
            <span class="text">{{ 'collections-constructor.content-selector.no-lessons2' | customLocale }}</span>
            <a [routerLink]="'/constructor'" class="link">
              {{ 'collections-constructor.content-selector.create-lesson' | customLocale }}
            </a>
          </div>
        </div>
      </ng-template>
    </div>
  </div>
  <app-modal
    *ngIf="!deviceService.isMobile() && showModal"
    [schedule]="!deviceService.isDesktop()"
    (closed)="onCloseCard()">
    <app-modal-body>
      <app-content-card
        class="modal"
        [playAutomatically]="true"
        [item_id]="item?.id"
        [canClose]="false"
        [inline]="false"
        [active]="false"
        [meta]="true"
        (close)="onCloseCard()">
      </app-content-card>
    </app-modal-body>
  </app-modal>
</ng-template>
